module.exports = __webpack_public_path__ + "6faafaf2bf0fd79edbec80a4b55c248a.png";